module.exports = __webpack_public_path__ + "static/media/ArtworkJ3Schedule2568.ab475561.png";